import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Plus } from "@phosphor-icons/react";

const TYPES = ["sedan","suv","van","pickup","motorcycle","ev","truck"];

export default function Vehicles() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ plate_number:"", vehicle_type:"sedan", brand:"", model:"", color:"" });

  const load = () => {
    const url = ["owner","tenant"].includes(user.role) ? `/vehicles?user_id=${user.id}` : "/vehicles";
    api.get(url).then(r => setList(r.data));
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/vehicles", { ...form, user_id: user.id });
      toast.success("Vehicle added");
      setForm({ plate_number:"", vehicle_type:"sedan", brand:"", model:"", color:"" });
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  return (
    <div className="space-y-6">
      <header>
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500">Vehicles</p>
        <h1 className="font-heading text-4xl font-black tracking-tighter mt-1">Fleet registry.</h1>
      </header>

      <Card className="bg-[#141414] border-zinc-800 p-6">
        <h3 className="font-heading text-xl font-bold flex items-center gap-2"><Plus size={20} /> Add Vehicle</h3>
        <form onSubmit={submit} className="mt-4 grid grid-cols-2 lg:grid-cols-5 gap-3 items-end">
          <div>
            <Label className="text-xs font-mono uppercase tracking-widest text-zinc-500">Plate</Label>
            <Input value={form.plate_number} onChange={(e) => setForm({ ...form, plate_number: e.target.value.toUpperCase() })} required className="bg-[#0F0F10] border-zinc-800 font-mono" data-testid="vehicle-plate-input" />
          </div>
          <div>
            <Label className="text-xs font-mono uppercase tracking-widest text-zinc-500">Type</Label>
            <Select value={form.vehicle_type} onValueChange={(v) => setForm({ ...form, vehicle_type: v })}>
              <SelectTrigger className="bg-[#0F0F10] border-zinc-800"><SelectValue /></SelectTrigger>
              <SelectContent>{TYPES.map(t => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs font-mono uppercase tracking-widest text-zinc-500">Brand</Label>
            <Input value={form.brand} onChange={(e) => setForm({ ...form, brand: e.target.value })} className="bg-[#0F0F10] border-zinc-800" />
          </div>
          <div>
            <Label className="text-xs font-mono uppercase tracking-widest text-zinc-500">Model</Label>
            <Input value={form.model} onChange={(e) => setForm({ ...form, model: e.target.value })} className="bg-[#0F0F10] border-zinc-800" />
          </div>
          <Button type="submit" className="bg-white text-black hover:bg-zinc-200" data-testid="vehicle-submit-button">Add</Button>
        </form>
      </Card>

      <Card className="bg-[#141414] border-zinc-800 p-6">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-zinc-500 text-xs font-mono uppercase">
                <th className="py-2 pr-4">Plate</th><th className="py-2 pr-4">Type</th>
                <th className="py-2 pr-4">Make</th><th className="py-2 pr-4">Color</th>
                <th className="py-2 pr-4">Owner</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800">
              {list.map(v => (
                <tr key={v.id}>
                  <td className="py-2 pr-4 font-mono text-base">{v.plate_number}</td>
                  <td className="py-2 pr-4 capitalize">{v.vehicle_type}</td>
                  <td className="py-2 pr-4">{v.brand} {v.model}</td>
                  <td className="py-2 pr-4">{v.color}</td>
                  <td className="py-2 pr-4 text-zinc-400 text-xs font-mono">{v.user_id ? v.user_id.slice(0,8) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
